import { DashboardCard } from "@dashboard/components/Card";
import { ConfirmButton, ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import { buttonMessages } from "@dashboard/intl";
import { Box, Textarea } from "@saleor/macaw-ui-next";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface OrderCustomerNoteEditProps {
  // The note the customer leaves at checkout, mirrored on the order as the
  // native `customerNote`. Editable here so staff can add or amend it while the
  // order is still a draft (Saleor only accepts `customerNote` on draft orders).
  note: string;
  disabled?: boolean;
  confirmButtonState: ConfirmButtonTransitionState;
  onSubmit: (note: string) => void;
}

const OrderCustomerNoteEdit = ({
  note,
  disabled = false,
  confirmButtonState,
  onSubmit,
}: OrderCustomerNoteEditProps) => {
  const intl = useIntl();
  const [value, setValue] = useState(note ?? "");

  // Keep the field in sync when the persisted note changes (e.g. after a save
  // refetch or when switching orders).
  useEffect(() => setValue(note ?? ""), [note]);

  return (
    <DashboardCard data-test-id="order-customer-note-edit">
      <DashboardCard.Header>
        <DashboardCard.Title>
          <FormattedMessage
            id="puALFo"
            defaultMessage="Notes"
            description="notes about customer, header"
          />
        </DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <Textarea
          data-test-id="order-customer-note-input"
          rows={3}
          value={value}
          disabled={disabled}
          placeholder={intl.formatMessage({
            id: "VrFy8e",
            defaultMessage: "No notes from customer",
          })}
          onChange={event => setValue(event.target.value)}
        />
        <Box display="flex" justifyContent="flex-end" marginTop={4}>
          <ConfirmButton
            data-test-id="order-customer-note-submit"
            transitionState={confirmButtonState}
            variant="primary"
            disabled={disabled || value === (note ?? "")}
            onClick={() => onSubmit(value)}
          >
            <FormattedMessage {...buttonMessages.save} />
          </ConfirmButton>
        </Box>
      </DashboardCard.Content>
    </DashboardCard>
  );
};

OrderCustomerNoteEdit.displayName = "OrderCustomerNoteEdit";
export default OrderCustomerNoteEdit;
